import axios from 'axios'

export default {
  redeemCode({commit, getters}) {
    let obj = {
      msisdn: getters.getRedemptionMsisdn,
      code: getters.getSelectedCodeForRedemption
    }
    return axios({
      url: '/web/game/redeemCode',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
  },
  getLostCodes({commit, getters}) {
    let obj = {
      msisdn: getters.getRedemptionMsisdn
    }
    return axios({
      url: '/web/game/getLostCodes',
      method: 'GET',
      params: obj
    })
  },
  assignExtraChance({commit, getters}, action) {
    let obj = {
      msisdn: getters.getRedemptionMsisdn,
      code: getters.getSelectedCodeForRedemption,
      assignExtraChance: getters.hasFoundBonusImage,
      gamePlayed: action
    }
    return axios({
      url: '/web/game/assignExtraChance',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
  },
  playGame({commit, getters}) {
    let obj = {
      msisdn: getters.getRedemptionMsisdn,
      code: getters.getSelectedCodeForRedemption
    }
    return axios({
      url: '/web/game/playGame',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },
  saveDeliveryData({commit, getters}, obj) {
    let param = {
      msisdn: getters.getRedemptionMsisdn
    }
    return axios({
      url: '/web/game/saveDeliveryData',
      method: 'POST',
      params: param,
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      data: obj
    })
  },
  assignReward({commit, getters}, obj) {
    return axios({
      url: '/web/game/assignReward',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      data: obj
    })
  },
  networkRewardInfo({commit, getters}, rewardIds) {
    let param = {
      rewardIds: rewardIds,
      msisdn: getters.getRedemptionMsisdn
    }
    return axios({
      url: '/web/game/networkRewardInfo',
      method: 'GET',
      params: param
    })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },


  // loadWinnersPageRewards({commit, getters}, context) {


  // const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()

  // This method accepts a date input, and a months input.The return is a date prior or after the month added as a parameter
  // const addMonths = (input, months) => {
  //   const date = new Date(input)
  //   date.setDate(1)
  //   date.setMonth(date.getMonth() + months)
  //   date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth()+1)))
  //   return date
  // }

  /*Simpler Version  * */
  //  const addMonths = (date, months) =>{
  //   date.setMonth(date.getMonth() + months)
  //   return date }
  //
  // const currentDate = new Date()
  // const quarter = Math.floor((currentDate.getMonth() / 3))
  //   let startDate = addMonths(currentDate,-6)
  //   return axios.get(`api/winners/monthRewards?startDate=${startDate.toISOString()}&endDate=${currentDate.toISOString()}`)
  //     .then((response) => {
  //       context.commit('updateWinnersData', response)
  //     })
  // },

  getPhysicalPrize({commit, getters}) {
    return axios({
      url: '/web/game/getPhysicalPrize',
      method: 'GET'
    })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  async accountLogin({commit, getters}) {
    let obj = {
      msisdn: getters.getMsisdn,
      password: getters.getPassword,
    }
    return axios({
      url: '/web/user/accountLogin',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('storeLoginResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  hasPassword({commit, getters}, payload) {
    let obj = {
      msisdn: payload.msisdn
    }
    return axios({
      url: '/web/user/customerHasPassword',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('updateHasPasswordResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  generatePin({commit}, payload) {
    let obj = {
      msisdn: payload.msisdn,
      social: false,
      forgotPassword: payload.forgotPassword
    }
    return axios({
      url: '/web/user/generatePin',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('updatePinResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  authenticatePin({commit, getters}, payload) {
    let obj = {
      msisdn: payload.msisdn,
      pin: payload.inputPin
    }
    return axios({
      url: '/web/user/authenticatePin',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('updateAuthenticatePinResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  async createPassword({commit}, payload) {
    let obj = {
      msisdn: payload.msisdn,
      password: payload.password
    }
    return axios({
      url: '/web/user/createPassword',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('updateCreatePasswordResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  optOutCustomer({commit}, payload) {
    let obj = {
      msisdn: payload.msisdn,
      code: payload.code,
      loggedIn: payload.loggedIn
    }
    return axios({
      url: '/web/user/optOutCustomer',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('updateOptOutResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  optInCustomer({commit}, payload) {
    let obj = {
      msisdn: payload.msisdn
    }
    return axios({
      url: '/web/user/optInCustomer',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('updateOptInResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  checkExistingMarketingConsent({commit}, payload) {
    let obj = {
      msisdn: payload.msisdn
    }
    return axios({
      url: '/web/user/checkExistingMarketingConsent',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('storeCheckMarketingConsentResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  updateMarketingConsent({commit}, payload) {
    let obj = {
      msisdn: payload.msisdn
    }
    return axios({
      url: '/web/user/updateMarketingConsent',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('storeUpdateMarketingConsentResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  compareCustomerPassword({commit}, payload) {
    let obj = {
      msisdn: payload.msisdn,
      password: payload.password
    }
    return axios({
      url: '/web/user/compareCustomerPassword',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('updateCompareCustomerPasswordResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  changePassword({commit}, payload) {
    let obj = {
      msisdn: payload.msisdn,
      password: payload.password
    }
    return axios({
      url: '/web/user/changePassword',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('updateChangePasswordResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  getCodeForLoggedInCustomer({commit, getters}) {
    let obj = {
      msisdn: getters.getRedemptionMsisdn
    }
    return axios({
      url: '/web/game/getCodeForLoggedInCustomer',
      method: 'GET',
      params: obj
    })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  loadMyAccount({commit, getters}) {
    let obj = {
      msisdn: getters.getMsisdn
    }
    return axios({
      url: '/web/user/loadAccount',
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .then((response) => {
        commit('updateAccountResponse', response.data)
      })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  loadConversation({commit, getters}) {
    let obj = {
      msisdn: getters.getRedemptionMsisdn,
      code: getters.getSelectedCodeForRedemption
    }
    return axios({
      url: '/web/game/loadConversation',
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  shortUrlCode({commit, getters}, payload) {
    let obj = {
      i: payload
    }
    return axios({
      url: '/web/game/shortUrlCode',
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

  zipCodeFinder({commit, getters}, payload) {
    let obj = {
      msisdn: getters.getRedemptionMsisdn,
      postCode: payload.postCode,
      houseNumber: payload.houseNumber
    }
    return axios({
      url: '/web/game/getDetailsFromZipCodeFinder',
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
      params: obj
    })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },
  getPhysicalPrizeWinners({commit, getters}) {
    return axios({
      url: '/api/winners/getPhysicalWinners',
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
    }).then((response) => {
      commit('updatePhysicalPrizeWinners', response.data)
    })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },
  getLastMonthWinners({commit, getters}) {
    return axios({
      url: '/api/winners/getLastMonthWinners',
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "Content-Transfer-Encoding": "application/x-www-form-urlencoded"
      },
    }).then((response) => {
      commit('updateLastMonthWinners', response.data)
    })
      .catch((error) => {
        console.log('an error occurred: ' + error)
      })
  },

}




// WEBPACK FOOTER //
// ./src/store/actions.js